// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TerceraChartCashItemSeriesDataType } from "../Series/TerceraChartCashItemSeriesEnums.js";
import { DataCacheToolRayType } from "../../Commons/cache/DataCacheToolEnums.js";
import { ToolView } from "./ToolView.js";
import { ToolViewUtils } from "./Utils/ToolViewUtils.js";

export let HorizontalLineToolView = function (tool)
{
    ToolView.call(this, tool);
};

HorizontalLineToolView.prototype = Object.create(ToolView.prototype);

HorizontalLineToolView.prototype.IsSelectCheck = function (x, y)
{
    var scrP = this.screenPoints[0];
    var pX = scrP[0];
    var pY = scrP[1];
    var TOOL_DX_HALF = ToolView.TOOL_DX / 2;

    var yTop = pY - TOOL_DX_HALF;
    var yBot = pY + TOOL_DX_HALF;
    return y >= yTop && y <= yBot && x > pX - TOOL_DX_HALF;
};

HorizontalLineToolView.prototype.DrawHorizontalLine = function (gr, ww, highlight)
{
    var dataCacheTool = this.dataCacheTool;

    var instrument = dataCacheTool.Instrument;

    var pY = dataCacheTool.Points[0][1];

    var scrP = this.screenPoints[0];
    var scrPX = scrP[0];
    var scrPY = scrP[1];

    var pen = highlight ? dataCacheTool.PenHighlight : dataCacheTool.Pen;
    var clientRect = ww.ClientRectangle;
    var clientRectRight = clientRect.X + clientRect.Width;
    var text = '';

    var dataType = ww.IsMainWindow && ww.ToolsRenderer.chart.cashItemSeriesSettings ?
        ww.ToolsRenderer.chart.cashItemSeriesSettings.DataType :
        TerceraChartCashItemSeriesDataType.Absolute;

    switch (dataType)
    {
        case TerceraChartCashItemSeriesDataType.Absolute:
            text = ToolViewUtils.FormatPrice(instrument, pY);
            break;
        case TerceraChartCashItemSeriesDataType.Relative:
            text = ww.ToolsRenderer.chart.cashItemSeriesSettings.relativeDataConverter.Calculate(pY).toString("N2") + "%";
            break;
        case TerceraChartCashItemSeriesDataType.Log:
            text = ToolViewUtils.FormatPrice(instrument, pY);
            break;
    }

    ToolView.DrawLineWithRay(gr, ww,
        scrPX, scrPY, clientRectRight, scrPY,
        dataCacheTool.LeftRay ? DataCacheToolRayType.LeftRay : DataCacheToolRayType.NoRay,
        pen);

    if (!highlight)
    {
        gr.DrawString(text, dataCacheTool.font, dataCacheTool.FontBrush,
            clientRectRight, scrPY, 'right', 'bottom');
    }
};

HorizontalLineToolView.prototype.Draw = function (gr, ww, param)
{
    this.DrawHorizontalLine(gr, ww, false);
    ToolView.prototype.Draw.call(this, gr, ww, param);
};

HorizontalLineToolView.prototype.DrawSelection = function (gr, ww)
{
    var clientRect = ww.ClientRectangle;

    var screenPoints = this.screenPoints;
    var scrP = screenPoints[0];
    var x = scrP[0];
    var y = scrP[1];

    this.DrawHorizontalLine(gr, ww, true);
    this.DrawSelectedLine(gr, ww, x, y, clientRect.X + clientRect.Width, y);
    this.DrawSelectedPoint(gr, ww, x, y);
};